<template>
  <div class="v-social-welfare-list">
    <div class="v-social-welfare-list__content">
      <sheet>
        <div class="purpose">
          <section-title title="他很小~他是我寶貝" />

          <p class="purpose__text">
            由於巴掌仙子的提早到來，經常帶給家庭許多衝擊和影響；致使早產兒家庭可能必須面對醫療、經濟、居家照顧以及家庭功能失調等問題。早產兒的父母親通常比一般的父母面臨更大的壓力，尤其是有疾病或身心障礙的早產兒父母。他們十分需要醫療及社會資源，包括非正式的家庭及社區支持系統資源，以及公、私部門的服務資源網絡，來協助他們勝任照顧的能力，讓早產兒平平安安、健健康康的成長。
          </p>
        </div>

        <div class="execute">
          <accordion :data="socialWelfare" />
        </div>
      </sheet>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import Accordion from '@/components/Global/Accordion.vue';
import SectionTitle from '@/components/Global/SectionTitle.vue';
import { socialWelfare } from '@/config/accordion';

export default defineComponent({
  name: 'SocialWelfare',
  components: {
    Accordion,
    SectionTitle,
  },
  setup() {
    return {
      socialWelfare,
    };
  },
});
</script>
<style lang="scss" scoped>
.purpose {
  &__text {
    @include font-normal();
  }
}

.budget {
  margin-top: 110px;
}

.execute {
  margin-top: 60px;
}
</style>
